import React from 'react';
import { MathJaxContext, MathJax } from 'better-react-mathjax';
import './ViewAnswers.css';

const ViewAnswers = ({ questions }) => {
  return (
    <MathJaxContext>
      <div className="view-answers-section">
        <h3 className="view-title">📘 Review Your Answers</h3>

        {questions?.map((q, idx) => {
          // Parse student answer correctly
const studentAnswer = q.type === 'multiple'
  ? (typeof q.selected_option === 'string' ? q.selected_option.toUpperCase().split(',') : q.selected_option || [])
  : (q.selected_option || '').toUpperCase();

// Parse correct options
const correctLetters = q.type === 'single'
  ? [q.correct_option.toUpperCase()]
  : (typeof q.correct_option === 'string' ? q.correct_option.toUpperCase().split(',') : []);

          return (
            <div key={idx} className="answer-card">
              {/* Question */}
              <div className="question">
                <strong>Q{idx + 1}:</strong>{' '}
                <MathJax>
                  <span dangerouslySetInnerHTML={{ __html: q.question }} />
                </MathJax>
              </div>

              {/* Options */}
              <div className="options">
                {q.options.map((opt, i) => {
                  const letter = String.fromCharCode(65 + i); // 'A', 'B', 'C', 'D'
                  const isSelected = q.type === 'single'
                    ? studentAnswer === letter
                    : Array.isArray(studentAnswer)
                      ? studentAnswer.includes(letter)
                      : false;
                  const isCorrect = correctLetters.includes(letter);

                  let className = 'option-item';
                  if (isSelected && isCorrect) className += ' correct';
                  else if (isSelected && !isCorrect) className += ' incorrect';
                  else if (!isSelected && isCorrect) className += ' actual-correct';

                  return (
                    <div key={i} className={className}>
                      <MathJax>
                        <span>
                          <strong>{letter}.</strong>{' '}
                          <span dangerouslySetInnerHTML={{ __html: opt }} />
                        </span>
                      </MathJax>
                    </div>
                  );
                })}
              </div>

              {/* Not Attempted */}
              {(studentAnswer.length === 0 || studentAnswer === '') && (
                <div className="not-attempted">❗ Not Attempted</div>
              )}

              {/* Model Answer / Explanation */}
              {q.model_answer ? (
                <div className="model-answer">
                  <strong>💡 Explanation:</strong>{' '}
                  <span dangerouslySetInnerHTML={{ __html: q.model_answer }} />
                </div>
              ) : (
                <div className="model-answer not-provided">
                  <em>💡 Explanation not provided</em>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </MathJaxContext>
  );
};

export default ViewAnswers;
